import { useAppSelector } from 'hooks/redux';
import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { accountsSelectors } from 'app-components/flux/accounts';

import type { AccountSourceConditionType } from 'app-components/flux/transaction-rules/transactionRulesTypes';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    '> *': {
      lineHeight: '24px',
    },
    '>div': {
      borderRight: `1px ${theme.palette.divider} solid`,
      padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
    },
    alignContent: 'flex-start',
    alignItems: 'center',
  },
  textPaddingAfter: {
    paddingRight: theme.spacing(0.5),
  },
}));

const AccountSource = ({ account }: { account?: AccountSourceConditionType }) => {
  const { classes } = useStyles();

  const allAccounts = useAppSelector(accountsSelectors.getResourcesById);
  if (!account) return <></>;

  if (account.accountSourceType !== 'SPECIFIC') {
    return (
      <Box className={classes.row}>
        <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
          Account is
        </Typography>
        <Typography className={classes.textPaddingAfter} variant='bodyMedium'>
          {account.accountSourceType}
        </Typography>
      </Box>
    );
  }

  const accountNames = account.accountSourceIds?.reduce<string[]>((acc, id) => {
    const accountName = id && allAccounts?.get(id)?.name;
    accountName && acc.push(accountName);
    return acc;
  }, []);

  return (
    <Box className={classes.row}>
      <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
        Account is
      </Typography>
      {accountNames?.map((accountName: string, index: number, array: any[]) => (
        <>
          <Typography className={classes.textPaddingAfter} variant='bodyMedium' key={accountName}>
            {accountName}
          </Typography>
          {index < array.length - 1 && (
            <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
              OR
            </Typography>
          )}
        </>
      ))}
    </Box>
  );
};

export default AccountSource;
